import React from "react"
import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import SI, { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"
import { AspectLink } from "../Filtering/AspectLink"
import { SpiritLink } from "../Filtering/SpiritLink"

export interface AspectOutcomeTableProps {
	plays: Play[]
}

export const AspectOutcomeTable = React.memo(function (props: AspectOutcomeTableProps): JSX.Element {

	const table = 'AspectOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'expansionOrder', ascending: true }

	// TODO: Show "No Aspect" too
	const tableData = SI.aspects.map(aspect => {

		const spiritPlays = props.plays.filter(play => play.spirits.some(playedSpirit => playedSpirit.aspect === aspect.name))
		const playCount = spiritPlays.length
		const winCount = spiritPlays.filter(play => play.outcome.victory).length
		const lossCount = playCount - winCount

		return {
			aspect,
			aspectName: aspect.name,
			expansionOrder: SI.expansionOrder.get(aspect.spirit.expansion)!,
			spiritNickname: aspect.spirit.nickname,
			playCount: playCount === 0 ? null : playCount,
			winCount: playCount === 0 ? null : winCount,
			lossCount: playCount === 0 ? null : lossCount,
			winRate: playCount === 0 ? null : winCount / playCount,
		}
	})

	Sorting.sort(tableData, sort, 'expansionOrder', 'spiritNickname', 'aspectName')

	return (
		<div>
			<table className="stats aspect-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'expansionOrder'} label='Aspect' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.aspect.name}>
								<th>
									<SpiritLink spirit={row.aspect.spirit} /> - <AspectLink aspectName={row.aspect.name} />
								</th>
								<td className="victory">{row.playCount ? row.winCount : ''}</td>
								<td className="loss">{row.playCount ? row.lossCount : ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
})
